export const itandiTaskWorkflowUrl = (workflowUuid: string): string =>
	`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_ITANDI_TASK}/main/tasks/workflows/${workflowUuid}`;
